document.addEventListener('DOMContentLoaded',()=>{
  document.querySelectorAll('[data-menu-toggle]').forEach(button=>button.addEventListener('click',()=>{
    const drawer=document.querySelector('[data-mobile-drawer]');
    const open=drawer.hasAttribute('hidden');
    drawer.toggleAttribute('hidden',!open);
    button.setAttribute('aria-expanded',String(open));
  }));
  document.querySelectorAll('[data-product-form]').forEach(form=>{
    const id=form.querySelector('[name="id"]');
    const variants=JSON.parse(form.querySelector('[data-variants]').textContent);
    form.addEventListener('change',()=>{
      const chosen=[...form.querySelectorAll('fieldset')].map(group=>group.querySelector('input:checked')?.value);
      const variant=variants.find(item=>item.options.every((value,index)=>value===chosen[index]));
      if(variant){
        id.value=variant.id;
        const price=form.closest('.pwh-buy')?.querySelector('[data-product-price]');
        if(price) price.textContent=new Intl.NumberFormat(document.documentElement.lang||'en',{style:'currency',currency:window.Shopify?.currency?.active||'USD'}).format(variant.price/100);
        const url=new URL(window.location.href);
        url.searchParams.set('variant',variant.id);
        window.history.replaceState({},'',url);
      }
      const submit=form.querySelector('[type="submit"]');
      submit.disabled=!variant?.available;
      submit.textContent=variant?.available?'ADD TO BAG':'SOLD OUT';
    });
  });
  document.querySelectorAll('[data-product-description]').forEach(description=>{
    const sizeFit=description.closest('.pwh-details')?.querySelector('[data-size-fit]');
    if(!sizeFit) return;
    [...description.querySelectorAll('table')].forEach(table=>{
      const wrap=document.createElement('div');
      wrap.className='pwh-size-table';
      table.parentNode.insertBefore(wrap,table);
      wrap.appendChild(table);
      sizeFit.appendChild(wrap);
    });
  });
});
document.addEventListener('DOMContentLoaded',()=>{document.querySelectorAll('[data-product-gallery]').forEach(gallery=>{const images=[...gallery.querySelectorAll('.pwh-gallery-image')];const thumbs=[...gallery.querySelectorAll('[data-gallery-thumb]')];const show=index=>{images.forEach((image,imageIndex)=>image.classList.toggle('is-active',imageIndex===index));thumbs.forEach((thumb,thumbIndex)=>{const active=thumbIndex===index;thumb.classList.toggle('is-active',active);thumb.setAttribute('aria-pressed',String(active));});};show(0);thumbs.forEach((thumb,index)=>thumb.addEventListener('click',()=>show(index)));});});

document.addEventListener('DOMContentLoaded',()=>{document.querySelectorAll('[data-product-gallery]').forEach(gallery=>{const images=[...gallery.querySelectorAll('.pwh-gallery-main img')];const thumbs=[...gallery.querySelectorAll('[data-gallery-thumb]')];const show=index=>{images.forEach((image,imageIndex)=>image.classList.toggle('is-active',imageIndex===index));thumbs.forEach((thumb,thumbIndex)=>{const active=thumbIndex===index;thumb.classList.toggle('is-active',active);thumb.setAttribute('aria-pressed',String(active));});};show(0);thumbs.forEach((thumb,index)=>thumb.addEventListener('click',()=>show(index)));});});

